import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import classNames from "classnames";
import { __ } from "@jti/fe-common";
import { CheckoutErrorSummary } from "../CheckoutErrorSummary";
import styles from "./CartItemList.module.scss";
export const CartItemList = memo(({ items, emptyMessage = __("cart.item_list.no_items"), renderItem, onRemoveItems, className = "", emptyClassName = "", testId = "", variant = "regular", }) => {
    if (items?.length > 0) {
        return (_jsxs(_Fragment, { children: [_jsx(CheckoutErrorSummary, { items: items, onRemoveItems: onRemoveItems, className: styles.checkoutErrorSummary, variant: variant }), _jsx("div", { "data-testid": testId, className: classNames({
                        [className]: !!className,
                        [styles.container]: true,
                    }), children: items.map((item) => renderItem(item)) })] }));
    }
    return (_jsx("div", { "data-testid": "emptyCartContainer", className: classNames({
            [emptyClassName]: !!emptyClassName,
            [styles.emptyMessage]: true,
        }), children: emptyMessage }));
});
//# sourceMappingURL=index.js.map